//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IEligibleUser } from '@apis/publish/publishApiModels';
import { IInstagramApiLocation } from '@models/IInstagramLocation';
import { IShopTag } from '@models/IShopTag';

export enum INSTAGRAM_POST_DETAILS_METADATA_ACTIONS {
  SET_ELIGIBLE_USERS = 'INSTAGRAM_POST_DETAILS_METADATA_ACTIONS/SET_ELIGIBLE_USERS',
  SET_LOCATION_SEARCH_TEXT = 'INSTAGRAM_POST_DETAILS_METADATA_ACTIONS/SET_LOCATION_SEARCH_TEXT',

  REQUEST_LOCATIONS = 'INSTAGRAM_POST_DETAILS_METADATA_ACTIONS/REQUEST_LOCATIONS',
  RECEIVE_LOCATIONS_SUCCEEDED = 'INSTAGRAM_POST_DETAILS_METADATA_ACTIONS/RECEIVE_LOCATIONS_SUCCEEDED',
  RECEIVE_LOCATIONS_FAILED = 'INSTAGRAM_POST_DETAILS_METADATA_ACTIONS/RECEIVE_LOCATIONS_FAILED',
}

export interface IInstagramPostDetailsMetadataState {
  eligibleUsers: IEligibleUser[];
  flags: IInstagramPostDetailsMetadataFlags;
  locationSearchText?: string;
  locationSuggestions: IInstagramApiLocation[];
}

interface IInstagramPostDetailsMetadataFlags {
  isFetchingLocationSuggestions: boolean;
}
